import React, { useState } from "react";
import Loader from "../../../loader/loader";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles({
    medium: {
        top: "25%",
        left: "25%",
    },
    small: {
        "& .app-loader": {
            width: 60,
            height: 60,
        },
    },
});

function EquipmentImageWithLoader(props) {
    const { id, size = "medium", src = null } = props;
    const [loading, setLoading] = useState(true);
    const classes = useStyles();

    const handleImageLoaded = () => {
        setLoading(false);
    };

    return (
        <>
            {loading && (
                <div
                    style={{
                        position: "absolute",
                        transform: "translate(-50%, -50%)",
                    }}
                    className={classes[size]}
                >
                    <Loader />
                </div>
            )}
            <img
                src={src !== null ? src : `/img-equipment/${id}`}
                onLoad={handleImageLoaded}
            />
        </>
    );
}

export default EquipmentImageWithLoader;
